import * as THREE from 'three';
import { ball, leaf, mesh, tube } from './art';
import { CAT_SECRET } from './data';
export const CAT_OBSTACLES = [
  { x: 52, z: 1, radius: 5.9 },
  { x: 48, z: 4.3, radius: 3.1 },
  { x: 48, z: 7.4, radius: 1.7 },
];

export function makeSleepingCat(parent: THREE.Group) {
  const group = new THREE.Group(); group.position.set(51, 0, 1); parent.add(group);
  const body = new THREE.Group(); group.add(body);
  ball(body, 1, 3, 0, 6.2, 3.2, 4.8, '#939c9f');
  ball(body, -.6, 2.7, 2.5, 4.2, 2.6, 3, '#e8e8dd');
  const paws = [ball(group, -3, .7, 6.4, 1.6, .75, 1.5, '#f0eee3'), ball(group, .4, .65, 5.5, 1.6, .7, 1.6, '#e8e8dd')];
  const backPaws = [ball(group, 5, .65, -2, 1.4, .7, 1.3, '#e8e8dd'), ball(group, 5, .65, 2, 1.4, .7, 1.3, '#e8e8dd')];
  for (const paw of paws) for (const x of [-.22, .22]) tube(paw, [new THREE.Vector3(x, .05, .87), new THREE.Vector3(x, .4, .8)], .025, '#a4a9a7');
  const head = new THREE.Group(); head.position.set(-3, 3, 3.3); group.add(head);
  ball(head, 0, 0, 0, 3.1, 2.65, 2.5, '#969fa2');
  const cheeks = [ball(head, -1.45, -.75, 1.9, 1.65, 1.25, .85, '#eeeee4'), ball(head, 1.45, -.75, 1.9, 1.65, 1.25, .85, '#eeeee4')];
  const cheekScales = cheeks.map(c => c.scale.clone());
  const ears: THREE.Group[] = [];
  for (const sign of [-1, 1]) {
    const ear = new THREE.Group(); ear.position.set(sign * 2, 1.7, -.05); head.add(ear); ears.push(ear);
    const outer = mesh(new THREE.ConeGeometry(1.15, 2.6, 3), '#939c9f', ear, 0, .65, 0); outer.rotation.y = Math.PI;
    const inner = mesh(new THREE.ConeGeometry(.66, 1.65, 3), '#c7a1a4', ear, 0, .65, .39); inner.rotation.y = Math.PI;
    ear.rotation.z = -sign * .23;
  }
  const openEye = new THREE.Group(); openEye.position.set(-1.25, .45, 2.55); head.add(openEye);
  ball(openEye, 0, 0, 0, .66, .33, .16, '#c5b775');
  ball(openEye, 0, 0, .14, .095, .3, .065, '#30393c');
  const secondEye = openEye.clone(); secondEye.position.x = 1.25; head.add(secondEye);
  const closedEyes: THREE.Mesh[] = [];
  for (const sign of [-1, 1]) {
    const lid = tube(head, [new THREE.Vector3(sign * .62, .12, 2.42), new THREE.Vector3(sign * 1.25, -.02, 2.52), new THREE.Vector3(sign * 1.85, .22, 2.24)], .085, '#495154');
    closedEyes.push(lid);
    tube(head, [new THREE.Vector3(sign * .65, .78, 2.32), new THREE.Vector3(sign * 1.72, 1.03, 2.1)], .11, '#707a7e');
    for (let i = 0; i < 3; i++) tube(head, [new THREE.Vector3(sign * 1.3, -.7 - i * .18, 2.57), new THREE.Vector3(sign * 3.7, -.35 - i * .5, 2.5)], .025, '#616b6d');
  }
  const nose = mesh(new THREE.ConeGeometry(.32, .36, 3), '#bb8f94', head, 0, -.55, 2.79); nose.rotation.z = Math.PI;
  const mouth = tube(head, [new THREE.Vector3(-.52, -1.28, 2.62), new THREE.Vector3(0, -1.05, 2.73), new THREE.Vector3(.52, -1.28, 2.62)], .055, '#6d6667');
  const yawn = ball(head, 0, -1, 2.71, .62, .75, .14, '#705054');
  ball(yawn, 0, -.18, .94, .5, .3, .08, '#d799a4');
  const tail = new THREE.Group(); tail.position.set(5, .8, -2); group.add(tail);
  tube(tail, [new THREE.Vector3(0, 0, 0), new THREE.Vector3(2.2, 0, 2.5), new THREE.Vector3(1, 0, 6), new THREE.Vector3(-2, 0, 7)], .7, '#808c91');
  ball(tail, -2, 0, 7, .72, .7, .72, '#e7e6dc');
  const playCrumb = mesh(new THREE.DodecahedronGeometry(.36), '#e7b461', parent, 45, .38, 10);
  tube(parent, [new THREE.Vector3(44.5, 0, 6), new THREE.Vector3(44.5, 1.5, 6)], .07, '#698459');
  leaf(parent, 44.5, .75, 6, 1.3, .5, '#82a360', .8);
  ball(parent, 44.5, 1.6, 6, .22, .22, .22, '#edcc77');
  let wasNear = false; let reactionStart = -100; let nextReaction = 0;
  let nextVisit = 0; let previousTime = 0; let walkTime = -1; let walkCycle = -1;
  let pendingVisit = false;
  let greetingUntil = -1; let lastTime = 0;
  const state = { awake: false, breath: 1, visits: 0, mood: 'sleeping', caption: '', sound: '' as '' | 'purr' | 'snore', pose: 0, walking: false };
  const collides = (x: number, z: number, dx = group.position.x - 51, dz = group.position.z - 1) => CAT_OBSTACLES.some(p => Math.hypot(x - p.x - dx, z - p.z - dz) < p.radius + .65);
  return {
    group, state,
    collides,
    restoreVisits(visits: number): void { state.visits = visits; },
    greet(): void { greetingUntil = lastTime + 5; state.sound = state.visits > 1 ? 'purr' : ''; },
    animate(time: number, x: number, z: number, allowVisit = true): void {
      const dt = Math.min(.05, Math.max(0, time - previousTime)); previousTime = time; lastTime = time;
      const near = Math.hypot(x - CAT_SECRET.x - (group.position.x - 51), z - CAT_SECRET.z - (group.position.z - 1)) < 7;
      if (near && !wasNear && time >= nextReaction) {
        reactionStart = time; nextReaction = time + 12;
        pendingVisit = time >= nextVisit;
      }
      if (near && allowVisit && pendingVisit) {
        state.visits = Math.min(100000, state.visits + 1); nextVisit = time + 30; pendingVisit = false; reactionStart = time;
        if (state.visits > 1) state.sound = 'purr';
      }
      if (!near) pendingVisit = false;
      wasNear = near;
      const elapsed = time - reactionStart;
      const phase = time % 72;
      let mood = phase < 14 ? 'sleeping' : phase < 18 ? 'yawning' : phase < 23 ? 'stretching' : phase < 28 ? 'loafing' : phase < 36 ? 'playing' : 'sleeping';
      const cycle = Math.floor(time / 72);
      if (phase >= 48 && phase < 49 && walkCycle !== cycle && !near && Math.hypot(x - 51, z - 1) > 18) { walkTime = 0; walkCycle = cycle; }
      if (walkTime >= 0) {
        const next = Math.min(12, walkTime + dt);
        const angle = next / 12 * Math.PI * 2;
        const dx = 1.5 * (Math.cos(angle) - 1); const dz = 1.2 * (1 - Math.cos(angle)) + .4 * Math.sin(angle);
        if (!near && !collides(x, z, dx, dz)) { walkTime = next; group.position.set(51 + dx, 0, 1 + dz); }
        mood = near ? 'watching' : next > 4 && next < 6 ? 'sniffing' : 'walking';
        if (walkTime >= 12) { walkTime = -1; group.position.set(51, 0, 1); mood = 'loafing'; }
      }
      if ((elapsed >= 0 && elapsed < 3) || time < greetingUntil) mood = state.visits > 1 ? 'slow blink' : 'watching';
      const friendly = mood === 'slow blink';
      const blink = friendly ? 1 - Math.pow(Math.max(0, Math.sin((time - reactionStart) * 1.7)), 2) : 1;
      const openness = mood === 'sleeping' ? 0 : mood === 'yawning' ? .1 : Math.max(.02, blink);
      const stretch = mood === 'stretching' ? Math.sin((phase - 18) / 5 * Math.PI) : 0;
      const yawning = mood === 'yawning' ? Math.sin((phase - 14) / 4 * Math.PI) : 0;
      state.mood = mood; state.walking = mood === 'walking';
      state.caption = mood === 'sleeping' && phase % 10 < 2 ? 'z z z...' : mood === 'slow blink' ? 'prrr...' : mood === 'yawning' ? 'yaaawn...' : mood === 'sniffing' ? 'sniff sniff' : mood === 'playing' ? '...who, me?' : mood === 'watching' ? 'hmph.' : '';
      state.awake = openness > .1; state.breath = 1 + Math.sin(time * 1.35) * .026;
      body.scale.set(1 + stretch * .07, state.breath - stretch * .12, 1 + stretch * .08);
      body.position.y = state.walking ? .35 : mood === 'loafing' ? -.18 : 0;
      head.rotation.x = -.025 + Math.sin(time * 1.35) * .012 - stretch * .12 + yawning * .2 + (mood === 'sniffing' ? .15 : 0);
      const headX = group.position.x - 3; const headZ = group.position.z + 3.3;
      const desiredYaw = near && openness > .1 ? THREE.MathUtils.clamp(Math.atan2(x - headX, z - headZ), -.5, .5) : 0;
      head.rotation.y = THREE.MathUtils.lerp(head.rotation.y, desiredYaw, Math.min(1, dt * 2));
      head.position.y = 3 + (state.walking ? .3 : 0);
      openEye.visible = openness > .03; secondEye.visible = openEye.visible && (state.visits > 1 || mood === 'playing');
      openEye.scale.y = secondEye.scale.y = Math.max(.01, openness * .65);
      closedEyes[0].visible = !openEye.visible; closedEyes[1].visible = !secondEye.visible;
      yawn.visible = yawning > .05; yawn.scale.y = Math.max(.01, yawning); mouth.visible = !yawn.visible;
      ears.forEach((ear, i) => { ear.rotation.z = (i ? -.23 : .23) + (time % (i ? 11 : 9) < .7 ? Math.sin(time % (i ? 11 : 9) * 18) * .13 : 0); ear.rotation.y = near ? desiredYaw * .5 : 0; });
      paws.forEach((paw, i) => {
        const stride = state.walking ? Math.sin(walkTime * 7 + i * Math.PI) : 0;
        paw.position.y = (i ? .65 : .7) + Math.max(0, stride) * .35 + (mood === 'playing' && i === 0 ? Math.max(0, Math.sin((phase - 28) * 1.5)) * .7 : mood === 'sleeping' && time % 17 < .8 ? Math.sin(time * 14) * .08 : 0);
        paw.position.z = (i ? 5.5 : 6.4) + stretch * .65 + stride * .35;
        paw.scale.z = mood === 'loafing' ? .8 : 1;
      });
      backPaws.forEach((paw, i) => { paw.position.y = .65 + (state.walking ? Math.max(0, Math.sin(walkTime * 7 + i * Math.PI + Math.PI)) * .3 : 0); });
      cheeks.forEach((cheek, i) => cheek.scale.copy(cheekScales[i]).multiplyScalar(1 + (friendly ? Math.sin(time * 5) * .014 : yawning * .035)));
      tail.rotation.y = Math.sin(time * .45) * .045 + (time % 13 < 1.3 ? Math.sin(time % 13 * 5) * .12 : 0);
      tail.rotation.z = mood === 'loafing' ? -.08 : 0;
      const roll = mood === 'playing' ? Math.sin((phase - 28) * 1.5) : 0;
      playCrumb.position.set(group.position.x - 4 + roll * .95, .38, group.position.z + 7.8 + Math.abs(roll) * .45);
      playCrumb.rotation.z = roll * 3; playCrumb.visible = mood === 'playing';
      state.pose = stretch + yawning + Math.max(0, walkTime) + head.rotation.y + openness * .1 + paws[0].position.y * .01;
      if (state.sound === '' && near && mood === 'sleeping' && Math.floor(time) % 16 === 0 && Math.floor(previousTime - dt) !== Math.floor(time)) state.sound = 'snore';
    },
  };
}
